<template>

  <list-item
    :booking="booking"
    :link="{ name: 'bookings.show', params: { id: booking.id } }"
  >
    <template v-slot:hero v-if="userCanSeeBudget" >
      <template v-if="booking.local_currency">
        {{ booking.local_budget_per_star | currency(booking.local_currency) }}
      </template>
      <template v-else>
        {{ booking.budget_per_star | currency(booking.currency) }}
      </template>
    </template>
    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{ booking.local_currency }}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
    </template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'

export default {
  mixins: [helpers],
  components: {
    ListItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  }
}
</script>
